import api from './api';

export interface GerarIaResponse {
  html: string;
}

export const llmService = {
  async gerarEscopo(markdownContent: string): Promise<GerarIaResponse> {
    const response = await api.post('/propostas/gerar-ia', { markdownContent });
    return response.data;
  },

  async ajustar(html: string, instrucao: string): Promise<GerarIaResponse> {
    const response = await api.post('/propostas/ajustar', { html, instrucao });
    return response.data;
  },
};
